import { fromJS } from 'immutable';

import * as FileActions from './actions';
import handleDefault from '../handleDefault';

const ENTITY_IDENTIFIER = 'files';
const initialState = fromJS({
  entities: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FileActions.EDIT: {
      const { id, name } = action.payload;
      return state.updateIn(['entities', String(id)], file => file.set('name', name));
    }

    case FileActions.REMOVE_REQUEST: {
      return state.deleteIn(['entities', action.payload.id]);
    }

    default:
      return handleDefault(ENTITY_IDENTIFIER)(state, action);
  }
}
